import { render, staticRenderFns } from "./banner-context-select.vue?vue&type=template&id=037091f4"
import script from "./banner-context-select.vue?vue&type=script&lang=js"
export * from "./banner-context-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports